/*
  Phantasmagorical: Kiwi size-recommender order stamp.
  WHY: the 30-day fit warranty is gated on whether the shopper used the Kiwi size
  recommender, but Kiwi records nothing on the order, so CS cannot verify eligibility.
  This writes the signal to the cart, which persists onto the order as note attributes.

  SIGNAL (either counts as "used Kiwi"):
    1) shopper opens the recommender via the custom "Find my size" button (.pg-fit__btn)
       or Kiwi's own control (.ks-calculator-modal-button), and/or
    2) Kiwi renders a recommendation control reading "We recommend size: X"
       (.ks-calculator-modal-button / ._ks_text), which also carries the size.

  WRITE: POST /cart/update.js with cart attributes:
    kiwi_used = "true"
    kiwi_recommended_size = "<size>"   (best-effort, e.g. "XL")
  A Shopify Flow (Order created, if kiwi_used == true, add tag "kiwi-stamped")
  gives CS an at-a-glance tag.

  Upgrade-safe: loaded via snippets/theme-globals.liquid on product pages. No core files touched.
*/
(function () {
  'use strict';
  if (window.__pgKiwiStampInstalled) return;
  window.__pgKiwiStampInstalled = true;

  var OK_SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', 'XXL', 'XXXL'];
  var PHRASE = 'we recommend size';
  var lastWritten = null;
  var wroteSize = false;
  var debounceTimer = null;
  var mo = null;

  function parseSize(text) {
    if (!text) return '';
    var lower = String(text).toLowerCase();
    var i = lower.indexOf(PHRASE);
    if (i === -1) return '';
    var rest = String(text).slice(i + PHRASE.length).replace(':', ' ').trim();
    var token = (rest.split(' ')[0] || '').split('\n')[0].toUpperCase();
    return OK_SIZES.indexOf(token) !== -1 ? token : '';
  }

  function currentRecommendedSize() {
    var el = document.querySelector('.ks-calculator-modal-button, ._ks_text, .ks-calculator-container');
    var size = el ? parseSize(el.textContent) : '';
    if (size) return size;
    var f = document.querySelector('.kiwi-sizing-modal .formula-text');
    if (f) {
      var t = (f.textContent || '').trim().toUpperCase();
      if (OK_SIZES.indexOf(t) !== -1) return t;
    }
    return '';
  }

  function writeStamp(size) {
    var key = 'true|' + (size || '');
    if (key === lastWritten) return;
    lastWritten = key;
    if (size) wroteSize = true;
    try {
      sessionStorage.setItem('pg_kiwi_used', 'true');
      if (size) sessionStorage.setItem('pg_kiwi_size', size);
    } catch (e) {}
    var attrs = { 'kiwi_used': 'true' };
    if (size) attrs['kiwi_recommended_size'] = size;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () { lastWritten = null; wroteSize = false; });
  }

  function maybeStamp() {
    var used = false;
    try { used = sessionStorage.getItem('pg_kiwi_used') === 'true'; } catch (e) {}
    var size = currentRecommendedSize();
    if (size) used = true;
    if (used) writeStamp(size);
  }

  function scheduleStamp() {
    if (debounceTimer) return;
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      maybeStamp();
      if (wroteSize && mo) { try { mo.disconnect(); } catch (e) {} }
    }, 500);
  }

  // 1) Explicit engagement: opening the recommender counts as using Kiwi.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.pg-fit__btn, .ks-calculator-modal-button') : null;
    if (t) {
      try { sessionStorage.setItem('pg_kiwi_used', 'true'); } catch (err) {}
      setTimeout(maybeStamp, 800);
    }
  }, true);

  // 2) Watch for Kiwi injecting / updating its recommendation, then capture the size.
  function start() {
    maybeStamp();
    try {
      mo = new MutationObserver(scheduleStamp);
      mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { if (mo) { try { mo.disconnect(); } catch (e) {} } }, 60000);
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
